import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormLayout, { FORM_MOBILE_QUERY } from "~/features/doctorForm/FormLayout";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import Step5 from "./steps/Step5";
import Step6 from "./steps/Step6";
import { sendRequest } from "~/services/requestForm";
import { getApiErrorCode } from "~/utils/apiError";
import PrepaymentFormData from "~/store/PrepaymentFormData.js";

const SUBMIT_ERROR = "Não foi possível enviar sua solicitação. Tente novamente em instantes ou entre em contato pelo WhatsApp 11 95213-3226.";
// Regra 2b (BE-1f): o BE recusa plantão ainda não encerrado com 422 VACANCY_NOT_CONCLUDED. Tratado sempre,
// mesmo com a flag desligada no FE.
export const NOT_CONCLUDED_ERROR =
  "Um dos plantões escolhidos ainda não terminou. Só dá para antecipar plantão já realizado: revise a seleção e envie de novo.";
const DUTIES_STEP = 3;
// O /features é rota logada (401 no formulário público): o formulário não consulta flags. O BE já filtra a lista
// com FORM_ONLY_CONCLUDED_ENABLED; a explicação no passo 4 espera o BE expor a flag na resposta pública (follow-up).
const ONLY_CONCLUDED = false;
const STEPS = [Step1, Step2, Step3, Step4, Step5, Step6];

const Stepper = () => {
  const mobile = useMediaQuery(FORM_MOBILE_QUERY);
  const [activeStep, setActiveStep] = useState(0);
  const [disableNext, setDisabledNext] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [channel, setChannel] = useState(null);

  useEffect(() => {
    if (typeof window.scrollTo === "function") window.scrollTo(0, 0);
  }, [activeStep]);

  const handleNext = async () => {
    if (activeStep !== 4) {
      setActiveStep((s) => s + 1);
      return;
    }
    setIsLoading(true);
    setSubmitError(null);
    try {
      const response = await sendRequest(PrepaymentFormData.data);
      if (response && response.status >= 200 && response.status < 300) {
        setChannel(response.data?.channel ?? null);
        setActiveStep((s) => s + 1);
      } else setSubmitError(SUBMIT_ERROR);
    } catch (e) {
      if (getApiErrorCode(e) === "VACANCY_NOT_CONCLUDED") {
        setSubmitError(NOT_CONCLUDED_ERROR);
        setActiveStep(DUTIES_STEP);
        return;
      }
      console.error("submit error", e);
      setSubmitError(SUBMIT_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const Step = STEPS[activeStep];

  return (
    <>
      <FormLayout
        mobile={mobile}
        step={activeStep}
        canNext={!disableNext}
        loading={isLoading}
        onBack={() => setActiveStep((s) => s - 1)}
        onNext={handleNext}
      >
        <Step
          setDisabledNext={setDisabledNext}
          setActiveStep={setActiveStep}
          mobile={mobile}
          onlyConcluded={ONLY_CONCLUDED}
          channel={channel}
        />
      </FormLayout>
      <Snackbar
        open={Boolean(submitError)}
        autoHideDuration={8000}
        onClose={() => setSubmitError(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error" variant="filled" onClose={() => setSubmitError(null)} sx={{ width: "100%" }}>
          {submitError}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Stepper;
